import React from "react";

function GraduateOutcomes() {
  return <div>GraduateOutcomes</div>;
}

export default GraduateOutcomes;
